import { InflateRequestMode } from '@sccs/types';
import { pipe } from 'valibot';
import {
  isMixedDlsTeaserResponse,
  isMixedOneSearchGraphQlResponse,
  isMixedSearchAlternativeResponse,
  isMixedT4Data,
  isVissVehicleTileDataQueryResponse,
  MixedResponseType,
} from '../types/GeneralTypes';
import {
  ConvertDlsSearchAlternativeToDlsTeaserTransformer,
  ConvertDlsSearchAlternativeToSimplePriceVehicleDataTransformer,
} from './dls/SearchAlternativeTransformer';
import { ConvertT4ToDlsTransformer } from './dls/T4PersonalizedToDlsTransformer';
import { ConvertDlsTeaserToVehicleDataTransformer } from './dls/TeaserTransformer';
import { ConvertOneSearchPreferenceToVehicleDataTransformer } from './onesearch/PreferenceTransformer';
import { ConvertOneSearchGraphQlToSimplePriceVehicleDataTransformer } from './onesearch/SearchTransformer';
import {
  ConvertSimplePriceDlsToVehicleDataTransformer,
  ConvertSimplePriceOneSearchToVehicleDataTransformer,
} from './simple-price/SimplePriceTransformer';
import { SchemaAny } from './VehicleTileDataSchema';
import { vissTileDataTransfomer } from './viss/TileDataTransformer';
import { ConvertOneSearchGraphQlToVehicleDataTransformer } from './onesearch/OneSearchGraphQlTransformer';

export const getVehicleTileDataSchema = (result: MixedResponseType) => {
  if (isMixedDlsTeaserResponse(result)) {
    return ConvertDlsTeaserToVehicleDataTransformer;
  }

  if (isMixedSearchAlternativeResponse(result)) {
    if (result.mode === InflateRequestMode.SIMPLE_PRICE) {
      return pipe(
        SchemaAny,
        ConvertDlsSearchAlternativeToSimplePriceVehicleDataTransformer,
        ConvertSimplePriceDlsToVehicleDataTransformer,
      );
    } else {
      return pipe(
        SchemaAny,
        ConvertDlsSearchAlternativeToDlsTeaserTransformer,
        ConvertDlsTeaserToVehicleDataTransformer,
      );
    }
  }

  if (isMixedOneSearchGraphQlResponse(result)) {
    if (result.mode === InflateRequestMode.SIMPLE_PRICE) {
      return pipe(
        SchemaAny,
        ConvertOneSearchGraphQlToSimplePriceVehicleDataTransformer,
        ConvertSimplePriceOneSearchToVehicleDataTransformer,
      );
    } else {
      return ConvertOneSearchGraphQlToVehicleDataTransformer;
    }
  }

  if (isMixedT4Data(result)) {
    return pipe(SchemaAny, ConvertT4ToDlsTransformer, ConvertDlsTeaserToVehicleDataTransformer);
  }

  if (isVissVehicleTileDataQueryResponse(result)) {
    return pipe(SchemaAny, vissTileDataTransfomer);
  }

  throw new Error('Unknown ResponseType');
};
